export const STATUS_FLOW_LOADING_TEXT = 'Завантажуємо історію...';
export const STATUS_FLOW_TOOLTIP_SEPARATOR = ' · ';
export const STATUS_FLOW_INFO_ICON_SIZE = 20;
export const STATUS_FLOW_TOOLTIP_PLACEMENT = 'bottom-start';

export const buildStatusFlowInfoAriaLabel = (label: string): string =>
  `Інформація про статус "${label}"`;
